import FirestoreService from "../firestore";
import { Company } from "@/types/company/company.types";

interface FirestoreResponse {
  entity?: string;
  [key: string]: any;
}

const companyService = {
  create: async (body?: Omit<Company, "id" | "createdAt" | "updatedAt">, userId?: string) => {
    const result = (await FirestoreService.request("create-company", body, "companies", userId)) as FirestoreResponse;
    const documentId = result?.entity;
    if (!documentId) {
      throw new Error("Failed to create company: No ID returned");
    }
    return documentId;
  },
  edit: async (id?: string, body?: Partial<Company>, userId?: string) => {
    const result = (await FirestoreService.request(
      "edit-company",
      { id, ...body },
      "companies",
      userId
    )) as FirestoreResponse;
    return result;
  },
  archive: async (documentId: string, userId?: string) => {
    const result = (await FirestoreService.request(
      "archive-company",
      { documentId },
      "companies",
      userId
    )) as FirestoreResponse;
    return result;
  },
  restore: async (documentId: string, userId?: string) => {
    const result = (await FirestoreService.request(
      "restore-company",
      { documentId },
      "companies",
      userId
    )) as FirestoreResponse;
    return result;
  },
};

export default companyService;
